import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
import { ScrollTable } from './ScrollTable';
const objections = ['This is not a collection of random exercises copied from the internet.', 'This is not a theoretical manual you need to rewrite before it works in a real lesson.', 'This is not content designed for a different kind of instructor that you have to completely adapt.'];
const volumeRows = [['Volume 1', 'Horse Safety, Handling & Stable Foundations', '16 lessons'], ['Volume 2', 'First Ride & Rider Foundations', '16 lessons'], ['Volume 3', 'Balance, Position & Independent Control', '15 lessons'], ['Volume 4', 'Trot Development & Transitions', '15 lessons'], ['Volume 5', 'Arena Skills, Poles & Progressive Challenges', '14 lessons'], ['Volume 6', 'Developing Rider Lessons', '14 lessons']];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-forest relative overflow-hidden" data-id="element-267" data-mp="2fge7blxhlmib">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-70" data-id="element-268" data-mp="2bvpagfq4gayk" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-269" data-mp="2gt8r1maakzto">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-270" data-mp="2kvvoc2pqfcy9">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-ivory/10 border border-gold/50 text-gold mb-5" data-id="element-271" data-mp="2puoz3ndmwpuq">
            <span className="text-2xl" aria-hidden="true" data-id="element-272" data-mp="1x6b31d63w3lt">
              🏆
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-ivory" data-id="element-273" data-mp="225nobthbx2ma">
            The most complete riding teaching system for instructors worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold mb-3" data-id="element-274" data-mp="19hi2t4igb9le">
            Horse Riding Instructor Ready™
          </h3>
          <p className="text-base md:text-lg text-ivory/80 mb-10" data-id="element-275" data-mp="1efjlhobyt6wc">
            6 Progressive Volumes · 90 Ready-to-Teach Lessons · 2 Professional
            Manuals · 5 Strategic Bonuses — everything ready to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left mb-16" data-id="element-276" data-mp="2cqbdovpkqulm">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-forest-dark p-6 rounded-2xl border border-ivory/10" data-id="element-277" data-mp="2qj10h2cxg3js">
            {objections.map(text => <div key={text} className="flex items-start gap-3" data-id="element-278" data-mp="1tul7sxeite2g">
                <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-279" data-mp="27tknvgnywkn0" />
                <p className="text-ivory/70 text-sm" data-id="element-280" data-mp="27qoqpujy1zzm">{text}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-pine p-6 rounded-2xl border border-gold/40 relative overflow-hidden" data-id="element-281" data-mp="3j7y7g9boudx8">
            <div className="flex items-start gap-3 relative z-10" data-id="element-282" data-mp="3mouc9hh6okr3">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-283" data-mp="3qss9fmmy7lhi" />
              <p className="text-ivory font-medium text-base leading-relaxed" data-id="element-284" data-mp="3cs7syx4ia1r6">
                This is a complete 6-in-1 professional teaching system — one
                purchase that covers every stage of the rider's journey, from
                the very first approach to a horse to independent developing
                rider work.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-left" data-id="element-285" data-mp="3vrbznz8krjfo">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-ivory mb-4 text-center" data-id="element-286" data-mp="sadbbcy3p8ve">
            What makes it a 6-in-1 system?
          </h3>
          <div className="space-y-4 text-ivory/80 text-base max-w-3xl mx-auto mb-10" data-id="element-287" data-mp="x2elmtbpkpis">
            <p data-id="element-288" data-mp="34l6c6rm82qfd">
              Most teaching resources give you exercises for one level, one
              stage, or one specific skill area.
            </p>
            <p data-id="element-289" data-mp="2vjgkrlscbrhl">
              Horse Riding Instructor Ready gives you six complete volumes in a
              single package — each one covering a full and distinct stage of
              the rider's development, structured so that every lesson connects
              directly to the one before it and the one after it.
            </p>
            <p data-id="element-290" data-mp="3jam1s4a0opth">
              You do not need to buy Volume 1 separately and then search for
              something else when your student progresses. You do not need to
              find a different resource for trot work, or another one for pole
              work, or another one for your developing riders.
            </p>
            <p className="text-gold font-bold" data-id="element-291" data-mp="avkg2y1gl81n">
              It is all here. In one system. From day one to developing rider.
            </p>
          </div>

          <ScrollTable className="max-w-3xl mx-auto" data-id="element-292" data-mp="dez0it9r2r8a">
            <thead data-id="element-293" data-mp="dga00gw5xctl">
              <tr className="bg-forest-dark text-ivory" data-id="element-294" data-mp="icgyxpq55o21">
                <th scope="col" className="px-4 py-3 font-bold" data-id="element-295" data-mp="id8syw43bdq7">
                  Volume
                </th>
                <th scope="col" className="px-4 py-3 font-bold" data-id="element-296" data-mp="neg3h2xmar0k">
                  Stage
                </th>
                <th scope="col" className="px-4 py-3 font-bold text-right" data-id="element-297" data-mp="wcrrqyb0hcpu">
                  Lessons
                </th>
              </tr>
            </thead>
            <tbody data-id="element-298" data-mp="11aa1gqwurvyw">
              {volumeRows.map(([vol, stage, lessons], i) => <tr key={vol} className={i % 2 === 0 ? 'bg-white' : 'bg-cream/70'} data-id="element-299" data-mp="163mhicnguug1" data-mpi={i}>
                  <th scope="row" className="px-4 py-3 font-bold text-forest whitespace-nowrap" data-id="element-300" data-mp="1b3qzk740vx8d">
                    {vol}
                  </th>
                  <td className="px-4 py-3 text-ink" data-id="element-301" data-mp="1jzzub8h227o6">{stage}</td>
                  <td className="px-4 py-3 text-right text-warmgray whitespace-nowrap" data-id="element-302" data-mp="3h3i6dw0owcd1">
                    {lessons}
                  </td>
                </tr>)}
              <tr className="bg-forest text-ivory" data-id="element-303" data-mp="3pvk77veo7unu">
                <th scope="row" className="px-4 py-3 font-bold" data-id="element-304" data-mp="3px4ztfhfd3j2">
                  TOTAL
                </th>
                <td className="px-4 py-3" data-id="element-305" data-mp="3o3qj5na0qiq">One complete system</td>
                <td className="px-4 py-3 text-right font-bold text-gold whitespace-nowrap" data-id="element-306" data-mp="3m93nlsg2oc0">
                  90 lessons
                </td>
              </tr>
            </tbody>
          </ScrollTable>
        </motion.div>
      </div>
    </section>;
}